export type NotificationExcludedType =
	| "ReminderTerm"
	| "IdentificationDocumentExpiry";

const REMINDER_EXCLUDED_TYPES: NotificationExcludedType[] = ["ReminderTerm"];
const DOCUMENT_EXCLUDED_TYPES: NotificationExcludedType[] = [
	"IdentificationDocumentExpiry",
];
const NO_EXCLUDED_TYPES: NotificationExcludedType[] = [];

export const getNotificationExcludedTypes = (
	hasRemindersRight: boolean,
	hasDocumentsFeature: boolean,
): NotificationExcludedType[] | undefined => {
	const excludedTypes = NO_EXCLUDED_TYPES.concat(
		hasRemindersRight ? NO_EXCLUDED_TYPES : REMINDER_EXCLUDED_TYPES,
		hasDocumentsFeature ? NO_EXCLUDED_TYPES : DOCUMENT_EXCLUDED_TYPES,
	);

	return excludedTypes.length > 0 ? excludedTypes : undefined;
};
